<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />

    <div class="news_animation">
      <p class="title">
        联系我们
      </p>
      <div class="lx_wm">
        <div class="content">
          <p>灵创科技</p>
          <p>联系地址：郑州市金水区国基路60号国家知识产权创意产业试点园区A座4楼409室</p>
          <p>联系电话：</p>
          <p><span>0371-55332258</span></p>
        </div>
        <div
          id="container"
          class="map_con"
        />
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
import AMap from '@amap/amap-jsapi-loader'

export default {
  name: 'Contact',
  components: {
    banner
  },
  data() {
    return {
      title: '联系我们',
      content: '联系我们--获得更多的技术支持',
      lbUrl: [],
      maker: null,
      map: null
    }
  },
  created() {},
  mounted() {
    this.initAMap()
  },
  methods: {
    initAMap() {
      AMap.load({
        key: '7c37a7295113d3c3db37477d6e216c85', // 设置您的key
        version: '2.0',
        plugins: [],
        AMapUI: {
          version: '1.1',
          plugins: ['control/BasicControl']
        },
        Loca: {
          version: '2.0'
        }
      })
        .then(AMap => {
          this.map = new AMap.Map('container', {
            rotateEnable: true,
            pitchEnable: true,
            zoom: 9,
            zooms: [5, 20],
            center: [113.672264, 34.819957], // 中心点坐标
            resizeEnable: true, // 是否监控地图容器尺寸变化
            mapStyle: 'amap://styles/fresh' // 地图样式
          })
          this.maker = new AMap.Marker({
            position: [113.672264, 34.819957] // 设置点标记的坐标
          })
          this.maker.content =
            '<div style="margin-right: 10px">国家知识产权创意产业试点园区A座4楼409室</div>'
          var content = '<div style="margin-right: 10px">国家知识产权创意产业试点园区A座4楼409室</div>'
          this.infoWindow = new AMap.InfoWindow({
            offset: new AMap.Pixel(0, -40),
            map: this.map,
            content: content // 传入 dom 对象，或者 html 字符串
          })
          this.maker.on('click', this.markerClick)
          this.infoWindow.open(this.map, [113.672264, 34.819957])
          this.maker.setMap(this.map)
          this.map.setFitView()
        })
        .catch(e => {})
    },
    markerClick(e) {
      this.infoWindow.setContent(e.target.content)
      this.infoWindow.open(this.map, e.target.getPosition())
    }
  }
}
</script>
<style lang="less" scoped>
.html {
  width: 100%;
  min-width: 1200px;

  .news_animation {
    width: 70%;
    margin: 0 auto;
    .title {
      text-align: center;
      font-size: 24px;
      color: rgb(51, 51, 51);
    }
    .subtitle {
      margin-top: 20px;
      text-align: center;
      color: rgb(153, 153, 153);
      font-size: 14px;
      word-break: normal;
      white-space: pre-wrap;
    }
    .lx_wm {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin: 40px auto 50px;

      .content {
        width: 49%;
        background: #f1f1f1;
        color: #666666;
        padding: 20px 0;
        border-radius: 2px;
        p {
          margin: 0 30px;
          line-height: 48px;
          font-size: 18px;

          span {
            display: inline-block;
            color: #3083eb;
            font-size: 36px;
          }
        }
        p:nth-child(1) {
          color: rgb(55, 60, 71);
          font-size: 24px;
        }
        .address {
          text-indent: 5em;
        }
      }
      .map_con {
        width: 49%;
        height: 385px;
        font-size: 14px;
        border-radius: 2px;
      }
    }
  }
}
</style>
